module.exports = __webpack_public_path__ + "img/icon_two_section_1267@2x.9cdeb0d3.png";